export default "__VITE_ASSET__a445fb07__"